import { createSlice } from '@reduxjs/toolkit'
import { failed, REQUEST_STATUSES } from './reducer-helper'
import { getDashboardData } from '../components/dashboard/slice'
import { createNewMeeting } from '../components/meeting/create-dialog/slice'

const initialState = {
  lastMeetings: null,
  statistic: null,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers(builder) {
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.lastMeetings = action.payload.lastMeetings
      state.statistic = action.payload.statistic
      state.status = REQUEST_STATUSES.DONE
    })
    builder.addCase(createNewMeeting.fulfilled, (state, action) => {
      if (state.lastMeetings) {
        state.lastMeetings.unshift(action.payload.meeting)
      }
    })
    builder.addCase(getDashboardData.rejected, failed)
  },
  reducers: {
    dashboardDataUnloaded: () => initialState,
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
  },
})

const selectSlice = (state) => state.dashboard
export const selectLastMeetings = (state) => selectSlice(state).lastMeetings
export const selectStatistic = (state) => selectSlice(state).statistic

export const selectRequestStatus = (state) => selectSlice(state).status

const { reducer, actions } = slice

export const { changeRequestStatus, dashboardDataUnloaded } = actions

export default reducer
